export default {
  clientId: 'NVH2_dXOcyj7nw',
  userAgent: 'saved_reddit',
  redirectUri: 'https://saved-reddit.web.app/',
};
